'use client';

import { useState } from 'react';
import { formatTelefon } from '@/lib/telefon';

interface TelefonInputProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
  hata?: string;
  zorunlu?: boolean;
}

export default function TelefonInput({
  value,
  onChange,
  label = 'Telefon',
  hata,
  zorunlu = false,
}: TelefonInputProps) {
  const [icHata, setIcHata] = useState('');

  const dogrula = () => {
    const rakamlar = value.replace(/\s/g, '');
    if (zorunlu && rakamlar.length === 0) {
      setIcHata('Telefon zorunludur');
    } else if (rakamlar.length > 0 && rakamlar.length !== 11) {
      setIcHata('Geçerli bir telefon numarası girin (11 hane)');
    } else {
      setIcHata('');
    }
  };

  const gosterilenHata = hata || icHata;

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {zorunlu ? `${label} *` : label}
      </label>
      <input
        type="tel"
        inputMode="numeric"
        value={formatTelefon(value)}
        placeholder="0 532 316 48 25"
        maxLength={15}
        className={`w-full border rounded-xl px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 ${gosterilenHata ? 'border-red-400' : 'border-gray-300'}`}
        onChange={(e) => {
          setIcHata('');
          onChange(formatTelefon(e.target.value));
        }}
        onBlur={dogrula}
      />
      {gosterilenHata && <p className="text-xs text-red-500 mt-1">{gosterilenHata}</p>}
    </div>
  );
}